import useSafeState from '../../utils/safe-state';
import React, {FC, ReactElement, ReactNode, useEffect} from 'react';
import {Form, Row, Col, Input, Button, message, Switch, InputNumber, Space, Popconfirm} from 'antd';
import {useAxios} from '../../utils/hooks';
import {AxiosResponse} from "axios";
import {Trans} from "@lingui/macro";
import {antdContext} from "../../utils/antdContext";
import SizeModel from "../../models/dto/size-model";

import Dragger from "antd/lib/upload/Dragger";
import {BackendFile} from "#/interfaces/BackendFile";
import {
    DeleteTwoTone, DownloadOutlined,
    InboxOutlined,
    InfoCircleTwoTone,
    PlusCircleTwoTone,
    QuestionCircleOutlined,
    WarningOutlined
} from "@ant-design/icons";
import {UploadFile} from "antd/es/upload/interface";
import {I18nProvider} from "@lingui/react";
import {i18n} from "@lingui/core";
import { Image } from 'antd';

interface Interface {
    data?: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

const OrderDrawer  = (props: Interface) => {

    const [loading, setLoading] = useSafeState(false);
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "")
    const [autoCompleteOptions, setAutoCompleteOptions] = useSafeState<any>();

    const data :any = props.data;
    const [form] = Form.useForm();
    const [fileList, setFileList] = useSafeState<Array<any>>([]);
    const [uploading, setUploading] = useSafeState(false);
    const [backendFiles, setBackendFiles] = useSafeState<Array<BackendFile>>([]);

    const folderName : string = data.productCode+'_'+data.lotNumber;

    let isEditMode = false;

    type ProductImage = {
        productCode: string,
        lotNumber: string,
        fileName: string,
        folder : string,
        id : number
    }

    useEffect(() => {

        form.resetFields();

        if (props.mode === "Edit") {

            let fieldsValues = [];
            for (const [key, value] of Object.entries(data)) {
                fieldsValues.push({name: key, value: value});
            }
            form.setFields(fieldsValues);

            isEditMode = true;
            getImages(props.data['productCode'], props.data['lotNumber']);

        } else if (props.mode === "Add new") {
            isEditMode = false;
        }
    },[])

    const getImages = (productCode: String, lotNumber: String) => {

        console.log(productCode, lotNumber);

        if(!axiosInstance.current){
            return;
        }

        axiosInstance.current.get('/resource/documents/get-all-by-product-code-and-lot-no?productCode=' + productCode + '&lotNo=' + (lotNumber ? lotNumber : ""))
            .then(function (response: AxiosResponse<any>) {
                if (Array.isArray(response.data)) {

                    let imgList: ProductImage[] = [];

                    response.data.forEach(value => {

                        imgList.push(
                            {
                                productCode: value.productCode,
                                lotNumber : value.lotNumber,
                                id: value.id,
                                folder: value.folder,
                                fileName: value.fileName
                            }
                        );
                    });
                    setBackendFiles(imgList);
                }
            })
            .catch(function (error: any) {
                console.log(error);//TODO::EndIt
            });
    }

    useEffect(() => {

        setBackendFiles(data.documents);

    },[data])

    const onReset = () => {
        form.resetFields();
    };



    const openNotification = (status:any) => {
        if (status === "error") {
            message.error(antdContext('Hiba mentés közben')).then(r => {console.log(r)});
        } else if (status === "success") {
            message.success(antdContext('Sikeres mentés'));
        } else {
            message.info(antdContext('Ismeretlen hiba')).then(r => {console.log(r)})
        }
        if (props.onClose){
            props.onClose();
        }
    };

    const config = { headers: {'Content-Type': 'application/json'} };

    const handleEdit = () => {

        if(axiosInstance.current != null){
            setLoading(true);
            axiosInstance.current.post("/resource/supplier-orders/add-files-to-order", {
                    productCode: form.getFieldValue(["productCode"]),
                    lotNumber: form.getFieldValue(["lotNumber"]),
                    file: fileList
                },
                config).then(() => {
                openNotification("success");
                setLoading(false);

            }).catch(function (error :any) {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }

    const handleUploadCsv = () => {
        if(axiosInstance.current != null){
            setLoading(true);
            const formData = new FormData();

            fileList.forEach(file => {
                formData.append('files', file);
            });

            axiosInstance.current.post("/resource/messages/upload-csv", formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
                openNotification("success");
                setLoading(false);
            }).catch(function (error :any) {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }

    const handleAddNew = () => {

        if(axiosInstance.current != null){
            setLoading(true);
            axiosInstance.current.post("/resource/supplier-orders/add-files-to-order", {
                    message:	form.getFieldValue(["message"]),
                    title:	form.getFieldValue(["title"]),
                    startDate:	form.getFieldValue(["startDate"]).format('YYYY-MM-DD'),
                    endDate: form.getFieldValue(["endDate"]).format('YYYY-MM-DD'),
                    supplierCode:{
                        code:form.getFieldValue(["supplierCode"])
                    },
                    file: fileList
                },
                config).then(function (response : AxiosResponse<any>){
                setUploading(true);

                if(fileList.length > 0 && axiosInstance.current != null){
                    const formData = new FormData();
                    fileList.forEach(file => {
                        formData.append('pic', file);
                        formData.append('deviceTypeId', response.data.name);
                    });

                    axiosInstance.current.post('/resource/device-types/upload-picture', formData)
                        .then(function (response : AxiosResponse<any>){
                            setUploading(false);
                            setFileList([]);
                            openNotification("success");
                            setLoading(false);
                        }).catch(function (error :any) {
                        openNotification("error");
                        setUploading(false);
                        setLoading(false);
                    });
                }else{
                    openNotification("success");
                    setLoading(false);
                }
            }).catch(function (error :any) {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }

    const uploadPropsCopy = {
        name: 'pic',
        multiple: false,
        onChange(info:any)
        {
            const { status } = info.file;

            if (status !== 'uploading') {
                console.log('uploading',info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} {<Trans>file uploaded successfully.</Trans>}`);
            } else if (status === 'error') {
                message.error(`${info.file.name} {<Trans>file upload failed.</Trans>}`);
            }
        },
        beforeUpload(file:any)
        {
            let fileList2 : Array<any> = fileList;
            fileList2.push(file);
            setFileList(fileList2);
            return false;
        },
        onRemove(file: UploadFile<any>)
        {
            let currentList : Array<UploadFile> = fileList;
            currentList = currentList.filter(value => value.name!=file.name);
            setFileList(currentList);
        }
    };

    const handleNewSubmit = () => {

        if(axiosInstance.current != null){
            setLoading(true);
            const formData = new FormData();
            fileList.forEach(file => {
                formData.append('files', file);
            });

            axiosInstance.current.post("/resource/supplier-orders/add-files-to-order", formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
                openNotification("success");
                setLoading(false);
            }).catch(function (error :any) {
                setLoading(false);
                openNotification("error");
                console.log(error)
            });
        }
    }

    const handleEditSubmit = () => {

        if(axiosInstance.current != null){
            setLoading(true);

            const formData = new FormData();
            fileList.forEach(file => {
                formData.append('files', file);
            });
            formData.append('orderNumber', data.orderNumber);
            formData.append('productCode', data.productCode);
            formData.append('lotNumber', data.lotNumber);
            formData.append('version', data.version);

            axiosInstance.current.put("/resource/supplier-orders/add-files-to-order",
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
                openNotification("success");
                setLoading(false);
            }).catch(function (error :any) {
                setLoading(false);
                openNotification("error");
                console.log(error)
            });
        }
    }

    const IconText = ({ icon , text  } : any) => (
        <div>
            {icon}
            {text}
        </div>
    );

    const antdContext: any = (text: string) => {
        return <I18nProvider i18n={i18n}>
            <Trans>{text}</Trans>
        </I18nProvider>;
    }

    const removeFile = (id : number) =>
    {

        if (!axiosInstance.current) {
            return;
        }

        axiosInstance.current.delete('/resource/documents/id/'+id,)
            .then(function (response: AxiosResponse<any>)
            {
                const current  = backendFiles;

                if(response.status == 200)
                {
                    setBackendFiles(current.filter(value => value.id != id));
                    message.success(antdContext('Success delete'));
                }
                else
                {
                    message.error(antdContext('Error on delete'));
                }

            })
            .catch(function (error: any) {
                console.log(error);//TODO::EndIt
            });

    }

    const generateFiles =  (msgDoc : BackendFile[]) => {

        let fileArray: ReactElement[] = [];

        if (msgDoc == null || msgDoc.length == 0) {

            fileArray.push(  <IconText
                icon={<WarningOutlined style={{marginRight:6}}/>}
                text={<Trans>Files not found to this message</Trans>}/>);

            return fileArray;
        }

        msgDoc.forEach((value, index) => {

            fileArray.push(
                <span style={{maxHeight: 300, paddingRight: "25px", overflow: "hidden"}}>
                    <div style={{marginBottom: "10px", display: "inline-block"}}>
                        <Image
                            style={{
                                display: "block",
                                objectFit: "cover",
                                width: 100,
                                height: 100
                            }}
                            src= { process.env.REACT_APP_API_BASE_URL + '/public/file/get?folder=' + value.folder + '&filename=' + folderName + "/" + value.fileName }
                            alt={'Nincs megjeleníthető kép'}
                        />
                    </div>

                    <Popconfirm
                        onConfirm={() => removeFile(value.id)}
                        okText={<Trans>Yes</Trans>}
                        cancelText={<Trans>No</Trans>}
                        title={<Trans>Are u sure?</Trans>} icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
                        <DeleteTwoTone style = {{position: 'absolute', paddingTop: "-80px"}} twoToneColor={"red"} onClick={() => console.log("")} />
                    </Popconfirm>
                </span>);

        });

        return fileArray;
    }

    return(
        <Form id={props.mode}  form={form} layout="vertical" onFinish={() => props.mode === "Edit" ?  handleEdit() : handleAddNew()}>
            {props.mode === "Add new" ?
                <>
                    <Row gutter={24}>
                        <Col span={24}>

                            <Form.Item
                                name="fenykep"
                                children={<Dragger {...uploadPropsCopy}>
                                    <div></div>
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text"><Trans>Click or drag file to this area to upload</Trans></p>

                                </Dragger>}
                            />

                        </Col>
                    </Row>
                </>
                :
                <>
                    <Row gutter={24}>
                        <Col span={24}>

                            <Form.Item
                                name="fenykep"
                                children={<Dragger {...uploadPropsCopy}>
                                    <div></div>
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text"><Trans>Click or drag file to this area to upload</Trans></p>
                                </Dragger>}
                            />

                        </Col>
                    </Row>
                    <Row style={{marginBottom:10}} gutter={24}>
                        <Col span={24}>
                            {generateFiles(backendFiles)}
                        </Col>
                    </Row>
                </>
            }
            {props.mode === "Edit" ?
                <Button style={{display:"flex"}} loading={loading} htmlType="button" type="primary" onClick={() => handleEditSubmit()}>
                    <Trans>Mentés</Trans>
                </Button>
                :
                props.mode === "Add new" ?
                    <>
                        <Button htmlType="button" style={{ marginRight: 8 }} onClick={() =>onReset()}>
                            <Trans>Vissza</Trans>
                        </Button>
                        <Button loading={loading} htmlType="button" type="primary" style={{ marginRight: 8 }} onClick={() => handleNewSubmit()}>
                            <Trans>Save</Trans>
                        </Button>
                    </>
                    :
                    <Button loading={loading} htmlType="button" type="primary" onClick={() => handleUploadCsv()}>
                        <Trans>Feltöltés</Trans>
                    </Button>

            }
        </Form>
    );

}
export default OrderDrawer;
